$(function() {
    //caches a jQuery object containing the header element
    var ctabar = $(".js-fixed-cta-footer-jquery");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 800) {
            ctabar.addClass('fixed-cta-footer--is-visible');
        } else {
            ctabar.removeClass("fixed-cta-footer--is-visible");
        }
    });
});
